import React from "react";
import BlinkitOnboardingUpload from "../../components/BlinkitOnboarding/BulkUploadDrivers";

const BlinkitOnboarding = (props) => {
  return <BlinkitOnboardingUpload />;
};

export default BlinkitOnboarding;
